import { useQueryState } from "nuqs";
import { sendEvent } from "@/features/analytics/gtm/event";
import { DIETS_PER_PAGE } from "@/features/diets/const";
import { getDiscountDetails } from "@/features/diets/helpers/get-discount-details";
import type { DietCatalog, DietCatalogDetail } from "@/features/diets/types";

export const useSelectItemEvent = () => {
  const [page] = useQueryState("page");

  const sendSelectItemEvent = ({
    index,
    diet,
    pagination = true,
    kcal,
  }: {
    index?: number;
    diet: DietCatalog | DietCatalogDetail;
    pagination?: boolean;
    kcal?: string;
  }) => {
    const parsedIndex = index ? index + 1 : 1;
    const parsedPage = pagination
      ? page
        ? Number.parseInt(page as string, 10) - 1
        : 0
      : 0;

    const { hasDiscount, priceAfterDiscount } = getDiscountDetails({
      price: diet.basePrice,
      discountCodes: diet.discountCodes,
    });

    const data = {
      item_list_name: window.location.pathname,
      items: [
        {
          item_id: diet.id,
          item_name: diet.name,
          item_variant: diet?.menuSelection ? "diet with choice" : "diet",
          discount:
            hasDiscount && priceAfterDiscount
              ? +(diet.basePrice - priceAfterDiscount).toFixed(2)
              : 0,
          price: priceAfterDiscount || diet.basePrice,
          quantity: 1,
          index: parsedPage * DIETS_PER_PAGE + parsedIndex,
          item_list_name: window.location.pathname,
          item_brand: diet.catering.name,
          item_category: diet?.tags.map((tag) => tag.slug).join(", "),
          ...(kcal && { item_category2: kcal }),
        },
      ],
    };

    sendEvent({
      event: "select_item",
      data,
    });
  };

  return { sendSelectItemEvent };
};
